export default {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};



// WEBPACK FOOTER //
// ./src/shared/constants/device-types.js